<svg
  width="342"
  height="300"
  viewBox="0 0 342 300"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_3359_5890)">
    <mask
      id="mask0_3359_5890"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="-1"
      y="0"
      width="332"
      height="284"
    >
      <path
        d="M330.184 127.029C330.184 213.419 260.242 283.444 173.955 283.444C87.6686 283.444 17.7262 213.419 17.7262 127.029C17.7262 108.822 -4.79496 93.5339 0.921667 77.2855C8.94029 54.4686 0.806568 55.1985 17.7262 38.6044C45.8873 10.9859 103.322 0 145.871 0C232.157 0 330.184 40.6402 330.184 127.029Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3359_5890)">
      <path
        d="M301.563 217.299C260.204 293.086 260.242 283.445 173.955 283.445C87.6689 283.445 17.7266 213.419 17.7266 127.03C17.7266 40.6405 126.189 52.8556 155.271 132.868C184.813 214.034 330.184 164.827 301.563 217.299Z"
        fill="url(#paint0_linear_3359_5890)"
      />
    </g>
    <mask
      id="mask1_3359_5890"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="-1"
      y="0"
      width="332"
      height="284"
    >
      <path
        d="M330.184 127.029C330.184 213.419 260.242 283.444 173.955 283.444C87.6686 283.444 17.7262 213.419 17.7262 127.029C17.7262 108.822 -4.79496 93.5339 0.921667 77.2855C8.94029 54.4686 0.806568 55.1985 17.7262 38.6044C45.8873 10.9859 103.322 0 145.871 0C232.157 0 330.184 40.6402 330.184 127.029Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_3359_5890)">
      <path
        d="M20.6802 72.7144C17.6493 72.7144 14.9252 70.6401 14.1963 67.5671C13.3522 63.9948 15.6158 60.4225 19.1839 59.5774L165.169 25.813C168.737 25.0063 172.305 27.2342 173.149 30.8066C173.993 34.3789 171.73 37.9513 168.161 38.7963L22.1765 72.5607C21.6778 72.676 21.179 72.7144 20.6802 72.7144Z"
        fill="#00A4B9"
      />
      <path
        d="M184.466 77.4392C182.932 77.4392 181.551 76.4405 181.129 74.904L174.491 51.242L159.528 40.7171C157.955 39.6031 157.572 37.452 158.684 35.8771C159.797 34.3022 161.945 33.9181 163.518 35.0321L179.517 46.2869C180.169 46.7478 180.63 47.4392 180.86 48.2075L187.804 73.0602C188.303 74.904 187.229 76.8246 185.387 77.3624C185.08 77.4008 184.773 77.4392 184.466 77.4392Z"
        fill="url(#paint1_linear_3359_5890)"
      />
      <path
        d="M55.6696 107.247C54.135 107.247 52.7538 106.248 52.3317 104.712L45.6943 81.0497L30.7313 70.5247C29.1583 69.4107 28.7746 67.2597 29.8873 65.6847C30.9999 64.1098 33.1484 63.7257 34.7215 64.8397L50.7203 76.0945C51.3726 76.5554 51.8713 77.2468 52.0632 78.0151L59.0075 102.868C59.5063 104.712 58.432 106.632 56.5904 107.17C56.2835 107.208 55.9766 107.247 55.6696 107.247Z"
        fill="url(#paint2_linear_3359_5890)"
      />
      <path
        d="M147.175 284.097C145.602 284.097 144.182 283.022 143.799 281.447C143.338 279.565 144.489 277.721 146.369 277.26L260.702 249.757C262.582 249.296 264.423 250.448 264.884 252.33C265.344 254.213 264.193 256.056 262.313 256.517L147.981 284.021C147.712 284.059 147.443 284.097 147.175 284.097Z"
        fill="url(#paint3_linear_3359_5890)"
      />
      <path
        d="M122.582 268.003C120.932 268.003 119.474 266.889 119.052 265.237C118.592 263.278 119.781 261.319 121.699 260.858L240.444 232.049C242.401 231.588 244.357 232.779 244.818 234.699C245.278 236.658 244.089 238.617 242.171 239.078L123.426 267.888C123.157 267.964 122.85 268.003 122.582 268.003Z"
        fill="url(#paint4_linear_3359_5890)"
      />
      <path
        d="M97.9883 251.908C96.3001 251.908 94.7655 250.755 94.3434 249.027C93.8447 246.991 95.0724 244.955 97.1058 244.456L220.263 214.341C222.296 213.841 224.33 215.07 224.828 217.106C225.327 219.142 224.099 221.178 222.066 221.677L98.9091 251.793C98.6021 251.869 98.2952 251.908 97.9883 251.908Z"
        fill="url(#paint5_linear_3359_5890)"
      />
      <path
        d="M73.395 235.813C71.6302 235.813 70.0188 234.622 69.5968 232.817C69.098 230.704 70.3641 228.592 72.4742 228.054L200.082 196.671C202.192 196.172 204.302 197.439 204.839 199.552C205.338 201.665 204.072 203.777 201.962 204.315L74.3542 235.736C74.0473 235.775 73.702 235.813 73.395 235.813Z"
        fill="url(#paint6_linear_3359_5890)"
      />
      <path
        d="M174.107 300C167.854 300 161.638 298.233 156.267 294.891L55.7848 231.78C50.5285 228.476 47.8045 222.369 48.8404 216.223C49.9147 210.077 54.5187 205.237 60.5806 203.892L165.705 180.422C175.987 178.118 186.883 180.845 194.864 187.759L269.103 251.754C273.439 255.48 275.319 261.28 274.014 266.85C272.71 272.42 268.489 276.76 262.926 278.182L182.395 298.963C179.671 299.654 176.87 300 174.107 300ZM61.9234 221.984L162.367 285.057C167.47 288.246 173.685 289.206 179.517 287.708L260.049 266.927C262.005 266.427 262.581 264.814 262.734 264.161C262.888 263.508 263.08 261.818 261.545 260.473L187.306 196.517C182.088 192.023 174.951 190.217 168.199 191.715L63.0744 215.185C60.8875 215.685 60.3504 217.452 60.2353 218.182C60.1202 218.911 60.0435 220.755 61.9234 221.984Z"
        fill="url(#paint7_linear_3359_5890)"
      />
      <path
        d="M269.104 251.716L194.865 187.721C186.884 180.845 175.988 178.118 165.706 180.384L60.5814 203.854C54.6346 205.198 50.1073 209.885 48.918 215.839C52.1791 217.337 55.9774 218.796 60.3896 220.064C60.121 219.296 60.1594 218.566 60.2361 218.143C60.3512 217.414 60.8883 215.647 63.0752 215.147L168.2 191.677C174.952 190.179 182.05 191.985 187.306 196.479L261.546 260.474C263.08 261.818 262.889 263.47 262.735 264.161C262.697 264.315 262.62 264.507 262.543 264.738C265.728 265.659 269.526 266.735 273.708 267.772C273.785 267.465 273.938 267.157 274.015 266.812C275.319 261.204 273.439 255.442 269.104 251.716Z"
        fill="url(#paint8_linear_3359_5890)"
      />
      <path
        d="M166.973 189.526C166.781 189.526 166.589 189.526 166.436 189.488C164.556 189.18 163.252 187.413 163.558 185.493L181.207 74.4429C181.514 72.5606 183.279 71.2546 185.197 71.5619C187.077 71.8692 188.382 73.6362 188.075 75.5568L170.426 186.607C170.119 188.297 168.623 189.526 166.973 189.526Z"
        fill="url(#paint9_linear_3359_5890)"
      />
      <path
        d="M140.692 195.403C140.577 195.403 140.423 195.403 140.308 195.365C138.39 195.173 137.047 193.444 137.239 191.523L149.401 81.7026C149.593 79.782 151.319 78.3991 153.238 78.6296C155.156 78.8217 156.499 80.5502 156.307 82.4708L144.145 192.292C143.953 194.097 142.418 195.403 140.692 195.403Z"
        fill="url(#paint10_linear_3359_5890)"
      />
      <path
        d="M114.41 201.28C114.333 201.28 114.256 201.28 114.18 201.28C112.261 201.165 110.803 199.513 110.918 197.592L117.556 89.0009C117.671 87.0803 119.359 85.6206 121.239 85.7359C123.157 85.8511 124.615 87.5028 124.5 89.4235L117.863 198.015C117.748 199.859 116.213 201.28 114.41 201.28Z"
        fill="url(#paint11_linear_3359_5890)"
      />
      <path
        d="M88.1295 207.119C86.1728 207.08 84.6381 205.544 84.6765 203.623L85.7891 96.2608C85.8275 94.3402 87.3622 92.8037 89.2421 92.8037H89.2805C91.1988 92.8421 92.7335 94.3786 92.7335 96.2992L91.6208 203.662C91.5825 205.582 90.0094 207.119 88.1295 207.119Z"
        fill="url(#paint12_linear_3359_5890)"
      />
      <path
        d="M61.8484 212.996C60.0069 212.996 58.4722 211.536 58.3955 209.654L53.9833 103.521C53.9066 101.601 55.4029 99.9872 57.3212 99.9104C59.2395 99.7951 60.8509 101.332 60.9277 103.252L65.3398 209.385C65.4165 211.306 63.9202 212.919 62.0019 212.996C61.9252 212.996 61.8868 212.996 61.8484 212.996Z"
        fill="url(#paint13_linear_3359_5890)"
      />
      <path
        d="M191.104 195.596C190.912 195.596 190.682 195.596 190.49 195.557C188.61 195.211 187.344 193.406 187.69 191.524L207.218 82.2408C207.563 80.3586 209.367 79.091 211.247 79.4367C213.127 79.7824 214.393 81.5878 214.047 83.47L194.519 192.715C194.212 194.405 192.754 195.596 191.104 195.596Z"
        fill="url(#paint14_linear_3359_5890)"
      />
      <path
        d="M209.635 211.575C209.367 211.575 209.098 211.537 208.83 211.46C206.95 210.999 205.837 209.117 206.259 207.273L230.775 106.402C231.236 104.52 233.116 103.406 234.957 103.829C236.837 104.289 237.95 106.172 237.528 108.015L213.05 208.886C212.628 210.538 211.208 211.575 209.635 211.575Z"
        fill="url(#paint15_linear_3359_5890)"
      />
      <path
        d="M228.206 227.593C227.86 227.593 227.515 227.554 227.131 227.439C225.29 226.863 224.292 224.904 224.868 223.06L254.372 130.64C254.947 128.796 256.904 127.798 258.745 128.374C260.587 128.95 261.585 130.909 261.009 132.753L231.544 225.173C231.045 226.632 229.664 227.593 228.206 227.593Z"
        fill="url(#paint16_linear_3359_5890)"
      />
      <path
        d="M246.775 243.573C246.353 243.573 245.892 243.496 245.47 243.304C243.705 242.574 242.861 240.538 243.59 238.771L277.967 154.802C278.696 153.035 280.729 152.19 282.494 152.92C284.259 153.649 285.103 155.685 284.374 157.452L249.959 241.46C249.422 242.766 248.118 243.573 246.775 243.573Z"
        fill="url(#paint17_linear_3359_5890)"
      />
      <path
        d="M265.344 259.59C264.806 259.59 264.269 259.475 263.732 259.206C262.044 258.323 261.392 256.21 262.274 254.52L301.638 178.963C302.521 177.273 304.631 176.62 306.319 177.503C308.007 178.387 308.659 180.499 307.777 182.189L268.413 257.708C267.799 258.899 266.571 259.59 265.344 259.59Z"
        fill="url(#paint18_linear_3359_5890)"
      />
      <path
        d="M261.508 275.992C260.971 275.992 260.434 275.877 259.935 275.608C258.209 274.725 257.556 272.65 258.4 270.922L297.112 194.75C297.995 193.022 300.067 192.369 301.793 193.214C303.52 194.097 304.172 196.172 303.328 197.9L264.577 274.11C263.964 275.301 262.774 275.992 261.508 275.992Z"
        fill="url(#paint19_linear_3359_5890)"
      />
      <path
        d="M234.652 282.945C234.191 282.945 233.731 282.868 233.309 282.676C231.544 281.908 230.738 279.872 231.467 278.105L263.043 203.777C263.772 202.01 265.844 201.203 267.609 201.933C269.373 202.702 270.179 204.737 269.45 206.504L237.874 280.832C237.299 282.138 235.994 282.945 234.652 282.945Z"
        fill="url(#paint20_linear_3359_5890)"
      />
      <path
        d="M207.833 289.859C207.449 289.859 207.104 289.782 206.72 289.667C204.917 289.053 203.919 287.094 204.533 285.25L228.972 212.804C229.586 210.999 231.543 210 233.385 210.615C235.188 211.229 236.185 213.188 235.572 215.032L211.132 287.516C210.633 288.937 209.252 289.859 207.833 289.859Z"
        fill="url(#paint21_linear_3359_5890)"
      />
      <path
        d="M180.976 296.812C180.708 296.812 180.439 296.774 180.132 296.697C178.252 296.236 177.139 294.354 177.6 292.51L194.903 221.87C195.364 219.987 197.244 218.873 199.085 219.334C200.965 219.795 202.078 221.677 201.617 223.521L184.314 294.161C183.969 295.736 182.549 296.812 180.976 296.812Z"
        fill="url(#paint22_linear_3359_5890)"
      />
      <path
        d="M159.299 293.431C159.069 293.431 158.839 293.393 158.609 293.354C156.729 292.97 155.501 291.126 155.885 289.244L170.502 216.683C170.886 214.801 172.689 213.572 174.608 213.956C176.488 214.34 177.715 216.184 177.332 218.066L162.714 290.627C162.369 292.279 160.949 293.431 159.299 293.431Z"
        fill="url(#paint23_linear_3359_5890)"
      />
      <path
        d="M134.207 277.682C134.054 277.682 133.939 277.682 133.785 277.644C131.867 277.414 130.524 275.685 130.754 273.764L140.384 192.676C140.614 190.755 142.303 189.411 144.259 189.641C146.178 189.872 147.52 191.6 147.29 193.521L137.66 274.609C137.43 276.376 135.934 277.682 134.207 277.682Z"
        fill="url(#paint24_linear_3359_5890)"
      />
      <path
        d="M109.076 261.895C109 261.895 108.961 261.895 108.884 261.895C106.966 261.78 105.508 260.166 105.585 258.246L110.227 168.591C110.342 166.671 111.954 165.173 113.872 165.288C115.79 165.403 117.248 167.017 117.172 168.937L112.529 258.591C112.453 260.435 110.918 261.895 109.076 261.895Z"
        fill="url(#paint25_linear_3359_5890)"
      />
      <path
        d="M83.9851 246.107C82.0668 246.107 80.5321 244.571 80.5321 242.65L80.1484 144.43C80.1484 142.509 81.6831 140.935 83.6014 140.935C85.5198 140.935 87.0544 142.471 87.0544 144.392L87.3997 242.612C87.4381 244.571 85.9034 246.107 83.9851 246.107Z"
        fill="url(#paint26_linear_3359_5890)"
      />
      <path
        d="M58.8547 230.358C57.0131 230.358 55.4784 228.899 55.4017 227.055L50.0687 120.269C49.9536 118.348 51.4499 116.735 53.3683 116.62C55.2866 116.504 56.898 118.002 57.0131 119.923L62.346 226.709C62.4611 228.63 60.9648 230.243 59.0465 230.358C58.9698 230.358 58.9314 230.358 58.8547 230.358Z"
        fill="url(#paint27_linear_3359_5890)"
      />
      <path
        d="M191.413 229.36C183.816 229.36 176.296 226.786 170.311 221.908L49.9166 124.609C45.3126 120.883 43.2791 114.968 44.622 109.206C45.9648 103.444 50.4153 99.0267 56.1703 97.7591L183.356 69.3725C194.674 66.8372 206.721 70.4864 214.778 78.8219L308.853 176.504C312.651 180.461 314.071 185.992 312.574 191.293C311.078 196.594 307.011 200.589 301.678 201.933L199.738 228.284C196.976 229.014 194.175 229.36 191.413 229.36ZM57.1679 115.582L177.562 212.919C182.934 217.26 190.147 218.835 196.822 217.106L298.762 190.755C300.642 190.256 301.256 188.796 301.41 188.143C301.602 187.529 301.832 185.954 300.527 184.533L206.452 86.85C201.158 81.3571 193.293 79.0139 185.888 80.6657L58.7025 109.052C56.6307 109.513 56.0552 111.165 55.9018 111.856C55.7099 112.509 55.5181 114.276 57.1679 115.582Z"
        fill="#00A4B9"
      />
      <path
        d="M311.615 180.461C310.925 179.04 310.004 177.695 308.891 176.504L214.778 78.822C206.721 70.4481 194.674 66.8374 183.356 69.3726L56.1703 97.7593C52.372 98.6043 49.1876 100.794 47.0391 103.828C47.0774 103.944 48.9958 108.899 55.7866 113.086C55.7483 112.586 55.7867 112.125 55.8634 111.857C56.0169 111.165 56.6307 109.513 58.6641 109.052L185.888 80.6658C193.293 79.0141 201.196 81.3956 206.452 86.8502L300.527 184.533C301.87 185.915 301.602 187.529 301.41 188.143C301.448 188.143 306.474 185.109 311.615 180.461Z"
        fill="#00A4B9"
      />
    </g>
    <path
      d="M224.83 181.537C224.792 181.537 224.753 181.537 224.753 181.537C221.876 181.076 220.226 180.576 220.149 180.538C219.842 180.423 219.689 180.115 219.766 179.808C219.881 179.501 220.188 179.347 220.495 179.424C220.495 179.424 222.144 179.962 224.907 180.384C225.214 180.423 225.444 180.73 225.406 181.037C225.329 181.344 225.099 181.537 224.83 181.537Z"
      fill="url(#paint28_linear_3359_5890)"
    />
    <path
      d="M233.884 182.19C233.577 182.19 233.309 181.921 233.309 181.613C233.309 181.306 233.577 181.037 233.884 181.037C236.877 180.999 239.869 180.73 242.862 180.269C243.169 180.231 243.476 180.423 243.514 180.73C243.552 181.037 243.361 181.344 243.054 181.383C239.984 181.882 236.915 182.151 233.884 182.19ZM251.763 179.232C251.533 179.232 251.303 179.078 251.226 178.848C251.111 178.54 251.303 178.233 251.609 178.118C254.449 177.196 257.249 176.044 259.973 174.738C260.28 174.584 260.587 174.699 260.741 175.006C260.894 175.275 260.779 175.659 260.472 175.775C257.71 177.119 254.832 178.31 251.955 179.232C251.878 179.232 251.84 179.232 251.763 179.232ZM268.069 171.28C267.877 171.28 267.685 171.204 267.57 171.012C267.378 170.743 267.455 170.397 267.723 170.205C270.179 168.553 272.596 166.709 274.898 164.712C275.128 164.52 275.512 164.52 275.704 164.789C275.896 165.019 275.896 165.403 275.627 165.595C273.287 167.631 270.831 169.513 268.337 171.165C268.299 171.242 268.184 171.28 268.069 171.28ZM281.842 159.449C281.689 159.449 281.574 159.411 281.459 159.296C281.228 159.065 281.229 158.72 281.42 158.489C283.415 156.338 285.41 154.033 287.29 151.613C287.482 151.344 287.866 151.306 288.096 151.498C288.365 151.69 288.403 152.074 288.211 152.305C286.293 154.763 284.298 157.106 282.303 159.296C282.149 159.373 281.996 159.449 281.842 159.449ZM293.007 145.083C292.892 145.083 292.777 145.045 292.7 145.006C292.432 144.814 292.355 144.469 292.547 144.2C294.158 141.741 295.731 139.129 297.227 136.441C297.381 136.172 297.726 136.056 298.033 136.21C298.302 136.364 298.417 136.709 298.263 137.017C296.729 139.744 295.156 142.356 293.544 144.853C293.352 144.968 293.199 145.083 293.007 145.083ZM301.87 129.219C301.793 129.219 301.716 129.219 301.601 129.142C301.294 128.989 301.179 128.643 301.333 128.374C301.755 127.49 302.177 126.607 302.599 125.685C303.481 123.764 304.287 121.882 304.939 120.038C305.054 119.731 305.399 119.578 305.668 119.693C305.975 119.808 306.128 120.154 306.013 120.423C305.323 122.266 304.517 124.187 303.635 126.146C303.213 127.068 302.791 127.951 302.368 128.835C302.292 129.065 302.1 129.219 301.87 129.219ZM308.047 112.126C308.008 112.126 307.97 112.126 307.932 112.126C307.625 112.049 307.433 111.741 307.471 111.434C308.047 108.592 308.354 105.826 308.354 103.214C308.354 102.983 308.354 102.753 308.354 102.522C308.354 102.215 308.584 101.946 308.929 101.946C309.275 101.946 309.505 102.177 309.505 102.522C309.505 102.753 309.505 103.022 309.505 103.252C309.505 105.903 309.198 108.745 308.584 111.703C308.584 111.933 308.315 112.126 308.047 112.126ZM274.783 111.165C274.476 111.165 274.207 110.935 274.207 110.589C274.207 110.282 274.438 110.013 274.783 109.974C277.622 109.859 280.615 109.475 283.684 108.784C283.991 108.707 284.298 108.899 284.375 109.206C284.451 109.513 284.259 109.821 283.953 109.898C280.806 110.666 277.737 111.088 274.783 111.165ZM265.728 110.512C265.69 110.512 265.652 110.512 265.613 110.512C262.582 109.936 259.628 108.937 256.866 107.593C256.597 107.439 256.444 107.094 256.597 106.825C256.751 106.556 257.096 106.402 257.364 106.556C260.05 107.862 262.889 108.822 265.844 109.398C266.15 109.475 266.381 109.782 266.304 110.09C266.227 110.32 265.997 110.512 265.728 110.512ZM292.47 107.324C292.24 107.324 292.01 107.17 291.933 106.94C291.818 106.633 291.971 106.325 292.278 106.21C294.964 105.211 297.765 103.944 300.527 102.561C300.795 102.407 301.141 102.522 301.294 102.83C301.448 103.099 301.333 103.444 301.026 103.598C298.187 105.019 295.386 106.287 292.662 107.324C292.623 107.324 292.547 107.324 292.47 107.324ZM249.499 102.676C249.384 102.676 249.231 102.638 249.116 102.522C246.852 100.64 244.703 98.4123 242.708 95.9155C242.517 95.6851 242.555 95.301 242.785 95.1089C243.015 94.9168 243.399 94.9552 243.591 95.1857C245.548 97.6057 247.658 99.7952 249.845 101.601C250.075 101.793 250.113 102.177 249.921 102.407C249.845 102.599 249.691 102.676 249.499 102.676ZM308.737 99.1806C308.546 99.1806 308.354 99.0654 308.239 98.9117C308.085 98.6428 308.162 98.2971 308.43 98.105C310.963 96.5301 313.456 94.84 315.95 93.0346C316.219 92.8426 316.564 92.9194 316.756 93.1499C316.948 93.4187 316.871 93.7645 316.641 93.9565C314.147 95.7619 311.576 97.4904 309.044 99.0654C308.968 99.1422 308.852 99.1806 308.737 99.1806ZM307.395 94.1486C307.164 94.1486 306.934 93.9949 306.857 93.7645C305.898 90.9604 304.402 88.3483 302.522 86.0436C302.33 85.8131 302.369 85.429 302.599 85.2369C302.829 85.0449 303.213 85.0833 303.404 85.3138C305.399 87.7337 306.934 90.4226 307.97 93.3803C308.085 93.6876 307.932 93.9949 307.625 94.1102C307.548 94.1102 307.471 94.1486 307.395 94.1486ZM239.601 88.0026C239.562 88.0026 239.562 88.0026 239.601 88.0026C239.255 88.0026 239.025 87.7337 239.025 87.4264C239.102 84.5071 240.713 81.7414 243.706 79.3983C243.975 79.2062 244.32 79.2446 244.512 79.5135C244.703 79.7824 244.665 80.1281 244.397 80.3202C241.673 82.4712 240.253 84.8528 240.176 87.4648C240.138 87.7721 239.908 88.0026 239.601 88.0026ZM296.115 80.3202C296 80.3202 295.885 80.2817 295.808 80.2433C293.429 78.7068 290.705 77.4392 287.712 76.4021C287.406 76.2869 287.252 75.9796 287.367 75.6723C287.482 75.365 287.789 75.2113 288.096 75.3266C291.165 76.3637 293.966 77.7081 296.422 79.283C296.69 79.4367 296.767 79.8208 296.614 80.0897C296.498 80.2049 296.307 80.3202 296.115 80.3202ZM252.108 76.2869C251.878 76.2869 251.648 76.1332 251.571 75.9027C251.456 75.5954 251.609 75.2881 251.916 75.1729C254.64 74.251 257.671 73.5212 260.856 73.0602C261.163 73.0218 261.47 73.2139 261.508 73.5596C261.546 73.8669 261.316 74.1742 261.009 74.2126C257.863 74.6736 254.909 75.365 252.262 76.2869C252.223 76.2485 252.147 76.2869 252.108 76.2869ZM279.08 74.251C279.042 74.251 279.003 74.251 279.003 74.251C276.087 73.7901 273.056 73.5596 270.025 73.5596C269.719 73.5596 269.45 73.2907 269.45 72.9834C269.45 72.6761 269.719 72.4072 270.025 72.4072C273.133 72.4072 276.202 72.6761 279.195 73.1371C279.502 73.1755 279.732 73.4828 279.694 73.7901C279.617 74.059 279.349 74.251 279.08 74.251Z"
      fill="url(#paint29_linear_3359_5890)"
    />
    <path
      d="M323.662 88.3101C323.509 88.3101 323.317 88.2333 323.202 88.1181C323.01 87.8876 323.01 87.5035 323.279 87.3114C325.466 85.4676 326.693 84.2769 326.693 84.2769C326.923 84.0464 327.307 84.0464 327.499 84.2769C327.729 84.5073 327.729 84.8915 327.499 85.0835C327.461 85.1219 326.233 86.3127 324.008 88.1949C323.892 88.2717 323.777 88.3101 323.662 88.3101Z"
      fill="url(#paint30_linear_3359_5890)"
    />
    <path
      d="M337.052 75.2499C337.052 75.2499 331.604 68.8351 329.877 71.9849C328.228 75.0963 337.052 75.2499 337.052 75.2499Z"
      fill="#00A4B9"
    />
    <path
      d="M341.924 75.173C342.384 76.4022 340.811 78.0923 338.432 78.9758C336.054 79.8593 333.752 79.552 333.329 78.3228C332.907 77.0936 334.442 75.4034 336.821 74.52C339.161 73.6365 341.463 73.9438 341.924 75.173Z"
      fill="#00A4B9"
    />
    <path
      d="M338.471 75.7491C338.471 75.7491 338.548 67.3369 335.21 68.566C331.872 69.8337 338.471 75.7491 338.471 75.7491Z"
      fill="#00A4B9"
    />
  </g>
  <defs>
    <linearGradient
      id="paint0_linear_3359_5890"
      x1="17.7276"
      y1="175.592"
      x2="305.272"
      y2="175.592"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.22e-06" stop-color="#E9F7FE" />
      <stop offset="1" stop-color="#F1FAFE" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_3359_5890"
      x1="158.048"
      y1="55.9438"
      x2="187.931"
      y2="55.9438"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_3359_5890"
      x1="29.2653"
      y1="85.7305"
      x2="59.1459"
      y2="85.7305"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_3359_5890"
      x1="143.709"
      y1="266.852"
      x2="264.982"
      y2="266.852"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#B0D4F0" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_3359_5890"
      x1="118.97"
      y1="249.962"
      x2="244.965"
      y2="249.962"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#B0D4F0" />
    </linearGradient>
    <linearGradient
      id="paint5_linear_3359_5890"
      x1="94.2319"
      y1="233.072"
      x2="224.944"
      y2="233.072"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#B0D4F0" />
    </linearGradient>
    <linearGradient
      id="paint6_linear_3359_5890"
      x1="69.4939"
      y1="216.183"
      x2="204.927"
      y2="216.183"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#B0D4F0" />
    </linearGradient>
    <linearGradient
      id="paint7_linear_3359_5890"
      x1="48.6204"
      y1="239.799"
      x2="274.419"
      y2="239.799"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#A0CDDE" />
    </linearGradient>
    <linearGradient
      id="paint8_linear_3359_5890"
      x1="48.9318"
      y1="223.677"
      x2="274.42"
      y2="223.677"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint9_linear_3359_5890"
      x1="163.489"
      y1="130.533"
      x2="188.097"
      y2="130.533"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint10_linear_3359_5890"
      x1="137.212"
      y1="137.014"
      x2="156.3"
      y2="137.014"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint11_linear_3359_5890"
      x1="110.932"
      y1="143.498"
      x2="124.502"
      y2="143.498"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint12_linear_3359_5890"
      x1="84.6537"
      y1="149.98"
      x2="92.705"
      y2="149.98"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint13_linear_3359_5890"
      x1="53.9671"
      y1="156.461"
      x2="65.3174"
      y2="156.461"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint14_linear_3359_5890"
      x1="187.613"
      y1="137.477"
      x2="214.094"
      y2="137.477"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint15_linear_3359_5890"
      x1="206.172"
      y1="157.687"
      x2="237.613"
      y2="157.687"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint16_linear_3359_5890"
      x1="224.736"
      y1="177.895"
      x2="261.13"
      y2="177.895"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint17_linear_3359_5890"
      x1="243.296"
      y1="198.107"
      x2="284.648"
      y2="198.107"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint18_linear_3359_5890"
      x1="261.856"
      y1="218.317"
      x2="308.164"
      y2="218.317"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint19_linear_3359_5890"
      x1="258.028"
      y1="234.441"
      x2="303.699"
      y2="234.441"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#C4D8E0" />
    </linearGradient>
    <linearGradient
      id="paint20_linear_3359_5890"
      x1="231.187"
      y1="242.296"
      x2="269.715"
      y2="242.296"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#C4D8E0" />
    </linearGradient>
    <linearGradient
      id="paint21_linear_3359_5890"
      x1="204.345"
      y1="250.153"
      x2="235.732"
      y2="250.153"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#C4D8E0" />
    </linearGradient>
    <linearGradient
      id="paint22_linear_3359_5890"
      x1="177.504"
      y1="258.01"
      x2="201.749"
      y2="258.01"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#C4D8E0" />
    </linearGradient>
    <linearGradient
      id="paint23_linear_3359_5890"
      x1="155.842"
      y1="253.687"
      x2="177.4"
      y2="253.687"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#C4D8E0" />
    </linearGradient>
    <linearGradient
      id="paint24_linear_3359_5890"
      x1="130.73"
      y1="233.637"
      x2="147.301"
      y2="233.637"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#C4D8E0" />
    </linearGradient>
    <linearGradient
      id="paint25_linear_3359_5890"
      x1="105.617"
      y1="213.585"
      x2="117.201"
      y2="213.585"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#C4D8E0" />
    </linearGradient>
    <linearGradient
      id="paint26_linear_3359_5890"
      x1="80.1622"
      y1="193.534"
      x2="87.4471"
      y2="193.534"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#C4D8E0" />
    </linearGradient>
    <linearGradient
      id="paint27_linear_3359_5890"
      x1="50.0634"
      y1="173.483"
      x2="62.3338"
      y2="173.483"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="5.4e-07" stop-color="#C5E8F4" />
      <stop offset="1" stop-color="#C4D8E0" />
    </linearGradient>
    <linearGradient
      id="paint28_linear_3359_5890"
      x1="220.185"
      y1="181.34"
      x2="346.224"
      y2="135.604"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint29_linear_3359_5890"
      x1="206.993"
      y1="143.547"
      x2="327.948"
      y2="99.6554"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <linearGradient
      id="paint30_linear_3359_5890"
      x1="201.921"
      y1="131.104"
      x2="327.97"
      y2="85.365"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="1.09e-06" stop-color="#B6D7E3" />
      <stop offset="1" stop-color="#AFD3F0" />
    </linearGradient>
    <clipPath id="clip0_3359_5890">
      <rect width="342" height="300" fill="white" />
    </clipPath>
  </defs>
</svg>
